import { LitElement, html, css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { colors } from '../styles/shared.js';
import { t, stageComment } from '../i18n.js';
import { cmdDismissModal } from '../commands.js';

@customElement('comment-modal')
export class CommentModal extends LitElement {
  static styles = [
    colors,
    css`
      :host {
        position: absolute;
        inset: 0;
        pointer-events: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 20px;
        cursor: pointer;
      }
      .comment-text {
        color: var(--color-white);
        font-size: 1.15rem;
        line-height: 1.6;
        max-width: 500px;
        text-align: center;
      }
      .dismiss {
        color: #ff0000;
        font-size: 1.05rem;
        position: absolute;
        bottom: env(safe-area-inset-bottom, 20px);
        left: 0;
        right: 0;
        text-align: center;
      }
    `,
  ];

  @property() accessor stageName = '';
  @property({ type: Boolean }) accessor isTouch = false;

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', cmdDismissModal);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', cmdDismissModal);
  }

  render() {
    const comment = stageComment(this.stageName, this.isTouch);
    if (!comment) return nothing;

    return html`
      <div class="comment-text">${comment}</div>
      <div class="dismiss">${t('comment-modal-dismiss')}</div>
    `;
  }
}
